<template>
    <v-container>
      <v-row>
        <v-col class="text-center">
<!--        <v-card>-->
          <h2>
            Ofte stilte spørsmål
          </h2>
          <br><br><br>
<!--          <v-card-text>-->
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>Hvorfor SiteSense?</v-expansion-panel-header>
                <v-expansion-panel-content>
                  SiteSense har bred erfaring med sensorer, automasjon og IoT,
                  og i forbindelse med integrasjoner med SD anlegg har vi kunnskaper om alle kjente protokoller som benyttes.<br>
                  I tillegg innehar vi kompetanse innen design og utvikling av både hardware og software.<br>

                  Dette gjør oss i stand til å levere solide løsninger – både enkle og spesialtilpassede løsninger.<br>
                  Åpenhet med tanke på løsninger og teknologi er viktig for oss,
                  og vi leverer løsninger som baserer seg på åpne standard protokoller og hardware.<br>
                  Dette betyr i større grad leverandøruavhengighet for våre kunder.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Er trådløs kommunikasjon stabilt?</v-expansion-panel-header>
                <v-expansion-panel-content>
                  Mange sverger fortsatt til kablede løsninger i tro om at trådløse løsninger ikke er like stabile,
                  og tenker ofte på vanlige WiFi nettverk.<br>
                  Den trådløse teknologien er godt utprøvd og har eksistert lenge,
                  og vår mangeårige erfaring tilsier at dette er like stabilt som kablede løsninger.<br>
                  Alle sensor- og styringsenheter kommuniserer via dedikerte lukket MESH nettverk (altså ikke WiFi),
                  og vi gjennomfører grundig analyse og testing av disse nettverkene i alle våre leveranser.
                  <br>
                  <b>Samtidig leverer vi selvsagt også løsninger som er 100% kablet.</b>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Hva er forskjellen på løsninger fra SiteSense og andre SD-anlegg?</v-expansion-panel-header>
                <v-expansion-panel-content>
                  Mange spør om SiteSense leverer SD-anlegg, og svaret er ja.<br>
                  Bygg kan med vår løsning i sin helhet automatiseres,
                  og i like stor og ofte større grad enn med tradisjonelle SD-anlegg.<br>
                  I etterstreber å gjenbruke de investeringene kunden allerede har gjort med styringsløsninger fra andre, og kan i tillegg komplimentere med nye sensorer og styringsenheter.<br>
                  Alle enheter vi leverer, er enten hyllevare eller våre egne produkter og begge er basert på åpne og dokumenterte standarder innen byggautomasjon.<br>
                  <b>Dette er fordi ingen kunder skal låses fast til en enkelt leverandør.</b>

                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Hvor mye koster løsningene i forhold til tradisjonelle SD-anlegg?</v-expansion-panel-header>
                <v-expansion-panel-content>
                  Med hensyn til priser er et fasitsvar som gjelder alle bygg og leverandører er umulig å komme med.
                  Erfaringsmessig ligger vårt styringssystem på under halvparten av prisen på tradisjonelle SD-anlegg.
                  Grunnen er rimeligere sensor- og styringsenheter,
                  lavere krav til utstyr som må installeres (PLS-er) og ikke minst enorme besparelser på installasjon pga. mindre kabling.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Hva skjer hvis byggene mister tilgang til internett?</v-expansion-panel-header>
                <v-expansion-panel-content>
                  All styring og automasjon i byggene fungerer uavhengig av Internett og plattformer i skyen.<br>
                  Ved brudd på tilgang til Internett vil man kun miste muligheter i dashboard og mobil app for å se status, sensordata og justering av setpunkter.<br>
                  Noen sensorløsninger vi leverer krever internettforbindelse, men ved et utfall av tilkobling, vil systemet midlertidig gå i en såkalt failsafe modus.<br>
                  Sammensetning av løsningen med disse faktorene er noe vi åpent kommuniserer med kunden i forkant av en tilbudsfase.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Hvordan lagres data fra sensorer og hvor lenge?</v-expansion-panel-header>
                <v-expansion-panel-content>
                  Alle sensorer kommuniserer med skyen og all data blir kontinuerlig lagret,
                  og blir lagret i 1 til 3 år avhengig av avtaler.
                  Dette gjør at man til enhver tid har siste data samt historikk tilgjengelig og enkelt kan kjøre ut rapporter til dokumentasjon.
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
<!--          </v-card-text>-->
<!--        </v-card>-->
        </v-col>
      </v-row>

    </v-container>
</template>

<script>

export default {
  name: 'FAQ-view',
  data: () => ({

  }),
  mounted () {
    window.scrollTo(0, 0)
  },

}
</script>
